export default "__VITE_ASSET__JWob4Ug3__"